import React from 'react';
import { DrawerContext, DrawerContextProps } from './DrawerProvider/DrawerContext';

const useDrawer = (): DrawerContextProps => React.useContext(DrawerContext) as DrawerContextProps;

export { useDrawer };
